import { useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks"; // Use your custom hooks
import AppInput from "@/components/AppInput";
import AppButton from "@/components/AppButton";
import AppCard from "@/components/AppCard";
import AppBox from "@/components/AppBox";
import { adminLogin } from "@/store/auth";

// Define types for the form and errors
interface FormState {
  email: string;
  password: string;
}

interface ErrorsState {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.auth);

  const [form, setForm] = useState<FormState>({ email: "", password: "" });
  const [errors, setErrors] = useState<ErrorsState>({ email: "", password: "" });

  // Handle form submission
  const handleSubmit = async () => {
    const newErrors: Partial<ErrorsState> = {};
    Object.keys(form).forEach((field) => {
      if (!form[field as keyof FormState]) {
        newErrors[field as keyof ErrorsState] =
          `${field.charAt(0).toUpperCase()}${field.slice(1)} is required`;
      }
    });
    setErrors((prev) => ({ ...prev, ...newErrors }));

    // Dispatch login if no errors
    if (Object.keys(newErrors).length === 0) {
      await dispatch(
        adminLogin({email: form.email, password: form.password,})
      );
    }
  };

  // Handle input changes
  const handleChange = (field: keyof FormState) => (value: string) => {
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <AppCard>
      <AppBox column gap={6}>
        <AppBox column gap={4}>
          {/* Email Input */}
          <AppInput
            type="email"
            label="Email Address"
            value={form.email}
            fullWidth
            onChange={handleChange("email")}
            autoFocus
            onPressEnter={handleSubmit}
            error={errors.email}
          />

          {/* Password Input */}
          <AppInput
            type="password"
            label="Password"
            value={form.password}
            fullWidth
            onChange={handleChange("password")}
            onPressEnter={handleSubmit}
            error={errors.password}
          />
        </AppBox>

        {/* Submit Button */}
        <AppButton onClick={handleSubmit} isLoading={status === "loading"}>
          Log In
        </AppButton>
      </AppBox>
    </AppCard>
  );
};

export default Login;